var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "boss-message-mail-body pega-pre-wrap",
    attrs: { "data-test": "body" },
    domProps: { innerHTML: _vm._s(_vm.$sanitize(_vm.renderBody)) },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }